<template>
    <div>
        <kendo-tabstrip v-if="model">
            <ul>
                <li class="k-state-active">{{ $t('tasks.details') }}</li>
                <li>{{ $t('tasks.history') }}</li>
                <li>{{ $t('coordinations.result') }}</li>
            </ul>
            <div>
                <div class="row">
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('coordinations.title')}}</label>
                        <div>{{model.title}}</div>
                    </div>
                    <div class="col-md-12 form-group">
                        <label class="font-weight-bold">{{$t('request_n')}}</label>
                        <div>{{model.request}}</div>
                    </div>
                    <div class="col-md-12 form-group" v-if="model.itemLink">
                        <label class="font-weight-bold">{{$t('coordinations.requestLink')}}</label>
                        <div><a :href="model.itemLink">{{$t('link')}}</a></div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('coordinations.startedBy')}}</label>
                        <div>{{model.createdByUserName}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('coordinations.coordinators')}}</label>
                        <div>{{model.coordinatorsAsString}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.status')}}</label>
                        <div>{{model.status}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.type')}}</label>
                        <div>{{model.type}}</div>
                    </div>
                    <div class="col-md-6 form-group">
                        <label class="font-weight-bold">{{$t('tasks.deadline')}}</label>
                        <div>{{ model.deadline ? $moment(model.deadline).format('DD.MM.YYYY HH:mm') : '' }}</div>
                    </div>
                    <div class="col-md-12 form-group" v-if="model.attachments">
                        <div class="font-weight-bold">{{$t('coordinations.attachments')}}</div>
                        <div>
                            <div lass="mb-2" v-for="item in model.attachments" :key="_uid+item.fileName">
                                <file-crud :file="item"
                                            :readonly="true"
                                            :showDescription="false"
                                            :type="item.docTypeCode">
                                </file-crud>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div v-if="show">
                    <history :taskId="model.id"></history>
                </div>
            </div>
            <div>
                <div v-if="show">
                    <result :taskId="model.id"></result>
                </div>
            </div>
        </kendo-tabstrip>
    </div>
</template>

<script>
    import FileCrud from '../common/FileCRUD';
    import history from './history';
    import result from './result';

    export default {
        components: {
            FileCrud,
            history,
            result
        },
        props: {
            model: {
                type: Object,
                default() {
                    return null
                }
            },
            show: {
                type: Boolean,
                required: false
            }
        }
    };
</script>
